import Navbar from "./Navbar"
import movieData from "../movieData.json"
import { useParams } from "react-router-dom"

function MovieDetails() {
    const params = useParams()

    const movie = movieData.find(movie => movie.title === params.movieTitle)

    const getHoursMinutes = (duration) => {
        const totalHours = (duration / 60);
        const remainingHours = Math.floor(totalHours);
        const minutes = (totalHours - remainingHours) * 60;
        const remainingMinutes = Math.round(minutes);

        let displayString = ""
      
        if (remainingHours)
            displayString += `${remainingHours} h `
        if (remainingMinutes) 
            displayString += `${remainingMinutes} min`

        return displayString
    }

    const openStreamingApp = (streamingService) => {
        let url = ""

        switch (streamingService) {
            case "Apple TV": 
                url = "https://tv.apple.com/"
                break
            case "Prime Video": 
                url =`https://www.amazon.com/s?k=${movie.title}&i=instant-video&crid=Z3ITG24QKAQC&sprefix=${movie.title}%2Caps%2C65&ref=nb_sb_noss_1`
                break
            case "HBO MAX": 
                url = "https://www.hbomax.com/"
                break
            case "Peacock": 
                url = "https://www.peacocktv.com"
                break
            case "YouTube": 
                url = "https://www.youtube.com/feed/storefront?bp=ogUCKAI%3D"
                break
            case "Disney +": 
                url ="https://www.disneyplus.com/home"
                break
            case "Hulu": 
                url = "https://www.hulu.com/welcome"
                break
            case "Netflix": 
                url = "https://www.netflix.com/browse"
                break
            default: 
                break
        }

        return url 
    }
      

    const createButtons = () => {
        if (movie.whereToWatch) {
            const whereToWatchButtons = movie.whereToWatch.map((streamingService) => {
                return (
                    <a href={ openStreamingApp(streamingService) } key={streamingService} >
                        <button 
                            className="where-to-watch-button"
                        >
                            {streamingService}
                        </button>
                    </a>
                )
            })
            return whereToWatchButtons
        }
    }

    const videoAsset = () => {
        if (movie.youtubeTrailerId) {
            return (
                <div className="movie-asset-container">
                    <iframe 
                        src={`https://www.youtube.com/embed/${movie.youtubeTrailerId}`} 
                        className="movie-iframe"
                        title={movie.youtubeTrailerId}
                    >
                    </iframe>
                </div>
            )
        } else {
            return (
                <div className="movie-asset">
                    <img src={movie.image} alt="movie cover" />
                </div>
            )
        }
    }

    return (
        <div className="movie-details">
            <Navbar title={movie.title} showFilter={false}/>

            { videoAsset() }

            <div className="movie-details-main">

                <p className="duration-release-year extra-light-color">{movie.duration ? getHoursMinutes(movie.duration) : ""}  {movie.year}</p>

                <div className="movie-description-container">
                    <h1>Description</h1>
                    <p className="movie-description">{movie.description}</p>
                </div>

                {movie.whereToWatch &&
                <div>
                    <h1 className="where-to-watch-header">Where To Watch</h1>
                    <div className="where-to-watch-container">
                    {createButtons()}
                    </div>
                </div>
                }
            </div>
        </div>
    )
}

export default MovieDetails